import { z } from '@/lib/zod'

export function EditNewsContentSchema() {
  return z.object({
    content: z.string().optional(),
  })
}

export type EditNewsContentForm = z.infer<
  ReturnType<typeof EditNewsContentSchema>
>
